import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";

// Add null checks for safety
const baseElement = document.getElementsByTagName("base")[0];
const baseUrl = baseElement?.getAttribute("href") || "/";
const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found. Make sure there is a div with id='root' in your HTML.");
}

// React 18: Use createRoot instead of ReactDOM.render
// Note: StrictMode is temporarily disabled due to Ant Design 4.x using deprecated findDOMNode
// Re-enable StrictMode after upgrading to Ant Design 5.x
const root = createRoot(rootElement);
root.render(
  <BrowserRouter basename={baseUrl}>
    <App />
  </BrowserRouter>
);

registerServiceWorker();
